import React, {useState} from 'react'
import {motion} from 'framer-motion'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'

const {FiSearch, FiX} = FiIcons

const SearchBar = ({onSearch, loading, error}) => {
  const [word, setWord] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (word.trim()) {
      onSearch(word.trim().toLowerCase())
    }
  }

  const handleClear = () => {
    setWord('')
  }

  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative">
          <input
            type="text"
            value={word}
            onChange={(e) => setWord(e.target.value)}
            placeholder="Enter a word to analyze..."
            className="w-full px-4 py-3 pl-12 pr-4 text-lg font-medium text-gray-900 card-subtle rounded-xl focus:border-primary focus:outline-none transition-colors shadow-sm"
            disabled={loading}
          />
          <SafeIcon
            icon={FiSearch}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl"
          />
          {word && (
            <button
              type="button"
              onClick={handleClear}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <SafeIcon icon={FiX} className="text-lg" />
            </button>
          )}
        </div>

        <motion.button
          type="submit"
          disabled={!word.trim() || loading}
          whileHover={{scale: word.trim() && !loading ? 1.02 : 1}}
          whileTap={{scale: word.trim() && !loading ? 0.98 : 1}}
          className="w-full mt-3 px-6 py-3 bg-primary text-white rounded-xl font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-primary-dark transition-colors shadow-sm"
        >
          {loading ? 'Analyzing...' : 'Analyze Word'}
        </motion.button>
      </form>

      {error && (
        <motion.div
          initial={{opacity: 0, y: -10}}
          animate={{opacity: 1, y: 0}}
          className="mt-3 p-3 card-subtle border border-red-200 rounded-lg"
        >
          <p className="text-red-700 text-sm font-medium">{error}</p>
        </motion.div>
      )}
    </div>
  )
}

export default SearchBar